module.exports = __webpack_public_path__ + "static/media/gcdef_10052.991708ab.ico";